import React, { useCallback, useEffect, useMemo, useState } from 'react';
import s from './s.module.less';
import { EditModuleEnum } from 'types/practiceFront';
import { Tabs } from 'antd';
import About from '../About';
import Specialties from '../Specialties';
// import Insurance from '../Insurance';
import Photos from '../Photos';
import MedicationsPrescribed from '../MedicationsPrescribed';
import ProListings from '../ProListings';
import { UniprofileFormData } from 'types/provider';
// import { INSURANCE_TYPE_CASH } from 'constants/common';
import type { TabsProps } from 'antd';
import { ISaveGenericInfoReqInput } from 'types/operation';
import { STATE } from 'constants/meta';

interface IProps {
    id: number;
    setSpecialtiesIsEdting?: (status: boolean) => void;
    specialtiesIsEdting?: boolean;
    providerData: UniprofileFormData;
    onSubmit?: (formValue: any, field: EditModuleEnum, callback?: () => void) => void;
    refetch: () => void;
    onTabChange: (key: string) => void;
    onSaveSuccess?: (value: string[]) => void;
    genericDetails?: ISaveGenericInfoReqInput;
    bookingListData?: any[];
    onAdSuccess?: () => void;
}

const UpdateUniprofile = ({
    genericDetails,
    id,
    setSpecialtiesIsEdting,
    specialtiesIsEdting,
    providerData,
    onSubmit,
    refetch,
    onTabChange,
    onSaveSuccess,
    bookingListData,
    onAdSuccess,
}: IProps) => {
    const [tabItems, setTabItems] = useState<TabsProps['items']>([]);

    const handleTabClick = useCallback(() => { }, []);

    // 从bookingListData中提取state数据作为appliedStates
    const appliedStatesFromBookingLinks = useMemo(() => {
        if (!bookingListData || bookingListData.length === 0) {
            return [];
        }

        // 提取所有state并去重
        const stateAbbreviations = bookingListData
            .map((item) => item.state)
            .filter((state) => !!state); // 过滤掉空值

        const uniqueStateAbbreviations = Array.from(new Set(stateAbbreviations)); // 去重

        // 将州缩写转换为州全称
        const stateFullNames = uniqueStateAbbreviations.map((stateCode) => {
            const stateInfo = STATE.find((state) => state.value === stateCode);
            return stateInfo ? stateInfo.label : stateCode; // 如果找不到映射，返回原始代码
        });

        return stateFullNames;
    }, [bookingListData]);

    useEffect(() => {
        const tabs = [
            {
                key: 'About me',
                label: 'About',
                children: <About genericDetails={genericDetails} providerData={providerData} onSubmit={onSubmit} refetch={refetch} />,
            },
        ];

        if (providerData?.practice?.specialtyList?.length > 0 || providerData?.practice?.conditionTreatedList?.length > 0) {
            tabs.push({
                key: 'Specialties',
                label: 'Specialties',
                children: <Specialties
                    onSaveSuccess={onSaveSuccess}
                    id={id}
                    providerId={providerData.id}
                    specialtiesIsEdting={specialtiesIsEdting}
                    setSpecialtiesIsEdting={setSpecialtiesIsEdting}
                    providerData={providerData}
                    refetch={refetch}
                />,
            });
        }

        // 添加 Medications Prescribed 作为独立的Tab
        tabs.push({
            key: 'Medications',
            label: 'Medications',
            children: <MedicationsPrescribed
                medications={genericDetails?.medications}
                appliedStates={appliedStatesFromBookingLinks}
                field={EditModuleEnum.GENERIC_MEDICATIONS_PRESCRIBED}
                onSubmit={onSubmit}
            />,
        });

        tabs.push({
            key: 'Pro-listings',
            label: 'Pro-listings',
            children: <ProListings providerId={providerData.id} onAdSuccess={onAdSuccess} />,
        });

        // if (providerData?.insurance?.supportPayType !== INSURANCE_TYPE_CASH) {
        //     tabs.push({
        //         key: tabs.length.toString(),
        //         label: 'Insurances',
        //         children: <Insurance providerData={providerData} />,
        //     });
        // }
        if (providerData?.profile?.additionalPhotoList && providerData?.profile?.additionalPhotoList.length > 0) {
            tabs.push({
                key: 'photos',
                label: 'Photos',
                children: <Photos providerData={providerData} />,
            });
        }

        setTabItems(tabs);
    }, [genericDetails, id, onSaveSuccess, onSubmit, providerData, refetch, setSpecialtiesIsEdting, specialtiesIsEdting]);

    return (
        <div className={s.wrap}>
            <Tabs
                tabBarStyle={{ position: 'sticky', top: 0, backgroundColor: '#F9FAFB', zIndex: 2, marginBottom: '24px' }}
                onTabClick={handleTabClick}
                onChange={(key: string) => {
                    let v = key;
                    if (key === 'photos') {
                        v = 'About me';
                    }
                    onTabChange(v);
                }}
                defaultActiveKey="About me"
                // activeKey={tabKey}
                items={tabItems}
                centered
            />
        </div>
    );
};

export default UpdateUniprofile;
